import { InvoiceClockOutlineIcon } from './InvoiceClockOutlineIcon';

/**
 * author: Jeff Anders
 * id 71498268-3E1E-4F4C-8510-4BA27D2F01F9
 * name invoice-clock-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-clock-outline.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceScheduledOutlineIcon = InvoiceClockOutlineIcon;
export default InvoiceScheduledOutlineIcon